export default __webpack_public_path__ + "static/media/FontAwesomeBrands.ec82f282.ttf";